/* eslint-disable */
import { useEffect, useState } from 'react';

// routing
import Routes from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import Loader from 'ui-component/Loader';

import ThemeCustomization from 'themes';
import { dispatch } from 'store';
import { getMenu } from 'store/slices/menu';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { HelmetProvider } from 'react-helmet-async';
import ConfirmationModal from 'views/reusable-element/ConfirmationModal';
import PreviewSelectedTemplateModal from 'views/reusable-element/PreviewSelectedTemplateModal';
import ErrorBoundary from 'ErrorBoundary';
import PdfViewerModal from 'views/reusable-element/PdfViewerModal';
import { ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import moment from 'moment-timezone';

// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

const App = () => {
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    moment.tz.setDefault('Asia/Kolkata');

    useEffect(() => {
        dispatch(getMenu()).then(() => {
            setLoading(true);
        });
    }, []);

    // useEffect(() => {
    //     const previousURLs = sessionStorage.getItem('lastVisitedURL');
    //     let urls = previousURLs ? previousURLs.split(',') : [];

    //     urls.push(location.pathname);

    //     if (urls.length > 2) {
    //         urls = urls.slice(-2);
    //     }

    //     sessionStorage.setItem('lastVisitedURL', urls.join(','));
    // }, [location.pathname]);

    if (!loading) return <Loader />;

    return (
        // <LocalizationProvider dateAdapter={AdapterDayjs}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <ThemeCustomization>
                <RTLLayout>
                    <Locales>
                        <NavigationScroll>
                            <AuthProvider>
                                <HelmetProvider>
                                    <ErrorBoundary>
                                        <>
                                            <Routes />
                                            <ToastContainer position="top-right" />
                                            <Snackbar />
                                            <ConfirmationModal />
                                            <PdfViewerModal />
                                            <PreviewSelectedTemplateModal />
                                        </>
                                    </ErrorBoundary>
                                </HelmetProvider>
                            </AuthProvider>
                        </NavigationScroll>
                    </Locales>
                </RTLLayout>
            </ThemeCustomization>
        </LocalizationProvider>
    );
};

export default App;
